import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { GrnReturnGridDto } from "./grn-rtn-grid";

export class AllGrnReturnResponse extends GlobalResponseObject {
    data?: GrnReturnGridDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GrnReturnGridDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}